/**
 * scale a shape to a given size
 */
export function scaleToPixel(el, size, applyScale) {
  if (applyScale === void 0) {
    applyScale = false;
  }
  var _a = el.getBBox(),
    width = _a.width,
    height = _a.height;
  var scale = size / Math.max(width, height);
  if (applyScale) el.scale(scale);
  return scale;
}